/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * PermissionDtoBase
 * auto generated base class for the model PermissionDtoModel.
 */
export const PermissionDtoModelBase = ModelBase
  .named('PermissionDto')
  .props({
    __typename: types.optional(types.literal("PermissionDto"), "PermissionDto"),
    id: types.identifier,
    action: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PermissionDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get action() { return this.__attr(`action`) }
}
export function selectFromPermissionDto() {
  return new PermissionDtoModelSelector()
}

export const permissionDtoModelPrimitives = selectFromPermissionDto().action
